module.exports = {"sorry":"Nous sommes désolés, une erreur est survenue.","tryagain":"Essayez de recharger"}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/PageError/localization/fr-FR/strings.json
// module id = 1177
// module chunks = 0